import { render, staticRenderFns } from "./IconText.vue?vue&type=template&id=f60193be&scoped=true"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"
import style0 from "./IconText.vue?vue&type=style&index=0&id=f60193be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60193be",
  null
  
)

export default component.exports